<template>
    <v-card class="half-card overflow-auto" elevation="3">
        <v-card-title>
            <h3>Recent Trips</h3>
        </v-card-title>
        <v-card-text class="pa-0">
            <p v-if="!selectedDevice">Please select an asset</p>

            <v-table v-if="selectedDevice" density="compact">
                <thead>
                <tr>
                    <th></th>
                    <th class="pa-0 px-1 text-center" style="width: 45px;">Score</th>
                    <th class="pa-0 px-1 text-left">Time</th>
                    <th class="pa-0 px-1 text-left">Dur.</th>
                    <th class="pa-0 px-1 text-left">Distance</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(trip, index) in trips" v-if="!loading && trips.length" :key="index">
                    <tr :class="`cursor-pointer text-left text-caption ${(selectedTrip?.id === trip.id)?'table-row-selected':''}`"
                        @contextmenu.prevent="(event) => selectedTrip?.id === trip.id ? showContextMenu(event,trip):''"
                        @click="updateTrip(trip)">
                        <td>
                            <v-btn :icon="`mdi-${expandRow===index?'minus':'plus'}`" density="compact" size="x-small"
                                   variant="text"
                                   @click="toggleRow(index)"/>
                        </td>
                        <td class="pa-0 px-1 text-center">
                            <v-chip v-if="hasTripScore(trip)"
                                    :color="tripScoreColor(trip.trip_score)"
                                    size="x-small" variant="tonal"
                                    class="font-weight-bold cursor-pointer"
                                    @click.stop="selectedScoreTrip = trip; tripScoreDialogSwitch = true">
                                {{ formatTripScore(trip.trip_score) }}
                            </v-chip>
                            <span v-else class="text-grey text-caption">-</span>
                        </td>
                        <td class="pa-0 px-1" style="min-width:125px;">{{
                                formatDateTime(trip.time)
                            }}
                        </td>
                        <td class="pa-0 px-1">{{
                                strOperations().formatDuration(trip.duration)
                            }}
                        </td>
                        <td class="pa-0 px-1">{{
                                strOperations().unitifyDistance(trip.distance, 'distance', 'km')
                            }}
                        </td>
                    </tr>
                    <tr v-if="expandRow === index">
                        <td class="pa-0" colspan="5">
                            <v-table class="bg-grey-lighten-4 ps-1 text-caption text-left" density="compact">
                                <tbody>
                                <tr v-if="trip.driver_name">
                                    <td class="pa-0 px-1 font-weight-bold">Driver</td>
                                    <td class="pa-0 px-1" colspan="3">{{ trip.driver_name }}</td>
                                </tr>
                                <tr>
                                    <td class="pa-0 px-1 font-weight-bold">Max Speed</td>
                                    <td class="pa-0 px-1">
                                        {{ trip.max_speed > 0 ? strOperations().unitifyDistance(trip.max_speed) : 0 }}
                                    </td>
                                    <td class="pa-0 px-1 font-weight-bold">Avg Speed</td>
                                    <td class="pa-0 px-1">{{
                                            trip.median_speed > 0 ? strOperations().unitifyDistance(trip.median_speed) : 0
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-0 px-1 font-weight-bold">Idle Percentage</td>
                                    <td class="pa-0 px-1">{{ trip.idle_percentage }}</td>
                                    <td class="pa-0 px-1 font-weight-bold">Avg Idle Time</td>
                                    <td class="pa-0 px-1">{{
                                            strOperations().formatDuration(trip.idle_avg_time)
                                        }}
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-0 px-1 font-weight-bold">From</td>
                                    <td class="pa-0 px-1" colspan="3">
                                        <div class="d-flex align-center ga-1">
                                            <v-tooltip v-if="trip.from" location="top">
                                                <template v-slot:activator="{ props }">
                                                    <span class="text-caption" v-bind="props">{{ trip.from.length > 35 ? trip.from.substr(0, 35) + '...' : trip.from }}</span>
                                                </template>
                                                <span>{{ trip.from }}</span>
                                            </v-tooltip>
                                            <span v-else-if="trip.start_location?.lat" class="text-caption">{{ trip.start_location.lat }}, {{ trip.start_location.lon }}</span>
                                            <v-tooltip v-if="trip.start_location?.lat" location="top" text="Open in Google Maps">
                                                <template v-slot:activator="{ props: tp }">
                                                    <v-btn :href="`https://www.google.com/maps?q=${trip.start_location.lat},${trip.start_location.lon}`"
                                                           target="_blank" icon="mdi-google-maps" size="x-small" variant="text"
                                                           color="red" density="compact" v-bind="tp" @click.stop/>
                                                </template>
                                            </v-tooltip>
                                            <v-tooltip v-if="trip.from || trip.start_location?.lat" location="top" text="Copy">
                                                <template v-slot:activator="{ props: tp }">
                                                    <v-btn icon="mdi-content-copy" size="x-small" variant="text"
                                                           color="grey" density="compact" v-bind="tp"
                                                           @click.stop="copyLocation(trip,'from')"/>
                                                </template>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="pa-0 px-1 font-weight-bold">To</td>
                                    <td class="pa-0 px-1" colspan="3">
                                        <div class="d-flex align-center ga-1">
                                            <v-tooltip v-if="trip.to" location="top">
                                                <template v-slot:activator="{ props }">
                                                    <span class="text-caption" v-bind="props">{{ trip.to.length > 35 ? trip.to.substr(0, 35) + '...' : trip.to }}</span>
                                                </template>
                                                <span>{{ trip.to }}</span>
                                            </v-tooltip>
                                            <span v-else-if="trip.end_location?.lat" class="text-caption">{{ trip.end_location.lat }}, {{ trip.end_location.lon }}</span>
                                            <v-tooltip v-if="trip.end_location?.lat" location="top" text="Open in Google Maps">
                                                <template v-slot:activator="{ props: tp }">
                                                    <v-btn :href="`https://www.google.com/maps?q=${trip.end_location.lat},${trip.end_location.lon}`"
                                                           target="_blank" icon="mdi-google-maps" size="x-small" variant="text"
                                                           color="red" density="compact" v-bind="tp" @click.stop/>
                                                </template>
                                            </v-tooltip>
                                            <v-tooltip v-if="trip.to || trip.end_location?.lat" location="top" text="Copy">
                                                <template v-slot:activator="{ props: tp }">
                                                    <v-btn icon="mdi-content-copy" size="x-small" variant="text"
                                                           color="grey" density="compact" v-bind="tp"
                                                           @click.stop="copyLocation(trip,'to')"/>
                                                </template>
                                            </v-tooltip>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </v-table>
                        </td>
                    </tr>

                    <v-menu v-if="menu.state"
                            v-model="menu.state"
                            :target="menu.position"
                            density="compact"
                    >
                        <v-list class="pa-0" density="compact">
                            <v-list-item
                                :href="`https://www.google.com/maps/dir/?api=1&origin=${selectedTrip.start_location['lat']},${selectedTrip.start_location['lon']}&destination=${selectedTrip.end_location['lat']},${selectedTrip.end_location['lon']}`"
                                target="_blank">Open Map
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
                <tr v-else>
                    <td v-if="loading" colspan="7">
                        <v-progress-circular color="primary" indeterminate/>
                    </td>
                    <td v-else colspan="7">No recent trips</td>
                </tr>
                </tbody>
            </v-table>

            <v-pagination v-if="totalPages > 1" v-model="currentPage" :length="totalPages" class="py-0 pt-2"
                          density="compact" @click="fetchTrips()"/>
        </v-card-text>
    </v-card>
    <TripScoreDialog
        v-if="tripScoreDialogSwitch"
        v-model="tripScoreDialogSwitch"
        :trip="selectedScoreTrip"
        @view-on-map="(t) => { selectedTrip = t; emits('selectedTrip', t); }"
    />
</template>

<script setup>
import {inject, ref, watch} from "vue";
import {send} from "@/composables/apiClient";
import {strOperations} from "@/composables/globals";
import {useClipboard} from "@/composables/clipboard";
import {useSnackbarStore} from "@/stores/snackBarStore";
import {geocodeLatLng, isValidAddress} from "@/composables/useGeocode";
import {formatDateTime} from "@/composables/useTimezone";
import {useTripScore} from "@/composables/useTripScore";
import TripScoreDialog from "@/components/dialogs/trips/TripScoreDialog.vue";
import {sameSerial} from '@/composables/deviceSerial';
import {addressWork} from '@/composables/tripAddress';

const trips = ref([]);
const expandRow = ref(0);
const totalPages = ref(1);
const currentPage = ref(1);
const loading = ref(false);
const menu = ref({state: 0});
const selectedTrip = ref(null);
const {copyToClipboard} = useClipboard();
const {showSnackbar} = useSnackbarStore();
const lastMqttUpdate = inject('lastMqttUpdate', ref(null));
const props = defineProps(["selectedDevice"]);
const emits = defineEmits(["selectedTrip"]);
const mqttMessageTypes = {
    MOTION_STARTED: 2,
    MOTION_IN_PROGRESS: 3,
    MOTION_ENDED: 4,
}


const showContextMenu = (e, trip) => {
    e.preventDefault();
    menu.value = {
        state: true,
        position: [e.clientX, e.clientY]
    };
}
const copyLocation = (trip, type) => {
    switch (type) {
        case 'from':
            if (isValidAddress(trip.from)) {
                copyToClipboard(trip.from);
            } else {
                copyToClipboard(trip.start_location['lat'] + ', ' + trip.start_location['lon']);
            }
            break
        case 'to':
            if (isValidAddress(trip.to)) {
                copyToClipboard(trip.to);
            } else {
                copyToClipboard(trip.end_location['lat'] + ', ' + trip.end_location['lon']);
            }
            break
    }
}
const {tripScoreColor, formatTripScore, hasTripScore} = useTripScore();
const tripScoreDialogSwitch = ref(false);
const selectedScoreTrip = ref(null);
const toggleRow = (index) => {
    expandRow.value = expandRow.value === index ? null : index;
}
const fetchTrips = (reset_page = false) => {
    if (reset_page) {
        totalPages.value = 1;
        currentPage.value = 1;
    }
    loading.value = true;
    send("get", `assets/${props.selectedDevice.asset_id}/trips`, {page: currentPage.value})
        .then((response) => {
            trips.value = response.data.data.data;
            totalPages.value = response.data.data.meta.last_page;
            currentPage.value = response.data.data.meta.current_page;
        })
        .catch((error) => {
            console.log(error);
            showSnackbar("Trips could not be loaded", "error");
        })
        .finally(() => {
            loading.value = false
            updateTrip(trips.value[0] ?? null);
        });
};
const geocodeAddress = async () => {
    const trip = selectedTrip.value;
    if (!trip) return null;

    const location = {start: trip.from, end: trip.to};

    const work = addressWork(trip);
    if (work.needStart && trip.start_location) {
        const resolved = await geocodeLatLng(trip.start_location);
        if (isValidAddress(resolved)) location['start'] = resolved;
    }
    // needEnd also covers an end the server has marked out of date, which is
    // how a traffic-stop address used to stay on a trip forever.
    if (work.needEnd && trip.end_location) {
        const resolved = await geocodeLatLng(trip.end_location);
        if (isValidAddress(resolved)) location['end'] = resolved;
    }
    return location;
}
const updateTripGeocodedAddress = (address) => {
    if (isValidAddress(address['start']) && isValidAddress(address['end']))
        send("post", `trips/update-location/${selectedTrip.value?.id}`, address)
            .catch((errorResponse) => console.log(errorResponse));
}
const updateTrip = async (newTrip) => {
    selectedTrip.value = newTrip;
    emits("selectedTrip", newTrip);
    // Skips a trip that is still running: its end point can still move, and
    // resolving it now is exactly how the wrong address came to be saved. It is
    // retried on a later load once the trip has settled.
    if (selectedTrip.value && !addressWork(selectedTrip.value).skip) {
        const location = await geocodeAddress();

        if (location && isValidAddress(location['start']) && isValidAddress(location['end'])) {
            const tripIndex = trips.value.findIndex((trip) => trip.id === selectedTrip.value.id);
            if (tripIndex > -1) {
                trips.value[tripIndex]['from'] = location['start'];
                trips.value[tripIndex]['to'] = location['end'];
                updateTripGeocodedAddress(location);
            }
        }
    }
}

watch(() => props.selectedDevice, (newDevice) => {
    trips.value = [];
    selectedTrip.value = null;
    if (newDevice?.asset_id) {
        fetchTrips(true);
    }
});
watch(lastMqttUpdate, async (update) => {
    if (!update || !props.selectedDevice) return;
    if (!sameSerial(update.slno, props.selectedDevice.slno)) return;

    const newLocation = update.data;
    if (newLocation?.trip) {
        let tripIndex = trips.value.findIndex((trip) => parseInt(trip.id) === newLocation.trip.id);
        if (tripIndex > -1) {
            trips.value[tripIndex]['to'] = newLocation.trip['to'];
            trips.value[tripIndex]['duration'] = newLocation.trip['duration'];
            trips.value[tripIndex]['distance'] = newLocation.trip['distance'];

            if (newLocation.message_type === mqttMessageTypes['MOTION_ENDED']) {
                // The broker sends avg/max speed as the raw speed_kmh2 field
                // (km/h x2); the API list returns them already normalised to MPH
                // (TripResource). Convert the live values to MPH too, else the
                // just-ended trip briefly renders ~3.2x too fast until a refetch.
            // The broker sends these on the raw two-scale field. Prefer the
            // resolved companions; keep the old halving as the fallback.
            const _toMph = (v) => (Number(v) || 0) / 2 * 0.621371;
                // The "Avg Speed" cell reads `median_speed` (what the API list
                // populates); the broker's live payload only carries `avg_speed`,
                // so write the normalised live average there or the just-ended
                // trip shows 0 until a refetch.
                trips.value[tripIndex]['median_speed'] = newLocation.trip['avg_speed_mph'] ?? _toMph(newLocation.trip['avg_speed']);
                trips.value[tripIndex]['max_speed'] = newLocation.trip['max_speed_mph'] ?? _toMph(newLocation.trip['max_speed']);
                trips.value[tripIndex]['end_location'] = newLocation.trip['end_location'];
                if (newLocation.trip_end_stats) {
                    trips.value[tripIndex]['idle_avg_time'] = newLocation.trip_end_stats['idle_avg_time'];
                    trips.value[tripIndex]['idle_percentage'] = newLocation.trip_end_stats['idle_percentage'];
                }
            }
            await geocodeLatLng(newLocation.trip['end_location']).then((response) => {
                    if (isValidAddress(response)) {
                        trips.value[tripIndex]['to'] = response;
                    }
                }
            )
        } else {
            // Same unit normalisation as the MOTION_ENDED branch above, which
            // this one was missing: the broker sends avg/max speed as raw
            // speed_kmh2 (km/h x2) while the API list returns MPH, and the
            // template formats with baseUnit 'miles' (no conversion). A newly
            // started trip therefore rendered ~3.2x too fast for its whole
            // life - a 60 km/h drive showed "120.00mph" - and the Avg Speed
            // cell, which reads median_speed, showed 0 because the live
            // payload only carries avg_speed.
            // The broker sends these on the raw two-scale field. The gateway now also
                // sends resolved companions; prefer those and keep the old halving as the
                // fallback so an un-migrated gateway renders exactly as before.
                const _toMph = (v) => (Number(v) || 0) / 2 * 0.621371;
            const _liveTrip = {...newLocation.trip};
            if (_liveTrip['max_speed'] !== undefined) {
                _liveTrip['max_speed'] = _liveTrip['max_speed_mph'] ?? _toMph(_liveTrip['max_speed']);
            }
            if (_liveTrip['avg_speed'] !== undefined) {
                _liveTrip['median_speed'] = _liveTrip['avg_speed_mph'] ?? _toMph(_liveTrip['avg_speed']);
            }
            trips.value.unshift({geo: 0, ..._liveTrip});
            trips.value[0]['to'] = null;
            trips.value[0]['from'] = null;
            if (trips.value.length === 1 || selectedTrip.value?.id === trips.value[1]?.['id']) {
                trips.value[0]['live'] = true;
                updateTrip(trips.value[0])
            }
        }
    }
});
</script>
